import * as React from "react";
import MenuItem from "./menuitem.component";

interface IMenuPageProps {
  isVisible: Boolean;
}

class MenuPage extends React.Component<IMenuPageProps> {
  addClasses = () => {
    return "menu-page " + (this.props.isVisible === true ? "show" : "");
  };

  render(): JSX.Element {
    return (
      <div className={this.addClasses()}>
        <MenuItem name="Home" link="/" />
        <MenuItem name="About" link={process.env.PUBLIC_URL + "/about"} />
        <MenuItem name="Contact us" link={process.env.PUBLIC_URL + "/contactus"} />
        <MenuItem name="Blog" link="https://medium.com/@fikafy" />
        <MenuItem name="Terms" link={process.env.PUBLIC_URL + "/terms"} />
        <MenuItem name="Privacy Policy" link={process.env.PUBLIC_URL + "/privacy"} />
      </div>
    );
  }
}

export default MenuPage;



// WEBPACK FOOTER //
// ./src/components/menupage.component.tsx